import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as CONST from '../../../../constants/FieldsConst';
import { dateformat, textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import * as ROUTES from '../../../../router/Routes';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allBloquesPedagogicosAction,
  deleteBloquesPedagogicosAction,
  setActivoBloquesPedagogicosAction,
} from '../BloquesPedagogicosAction';
import { PARAMS_BLOQUES_PEDAGOGICOS } from '../BloquesPedagogicosReducer';

const ListadoBloquesPedagogicos = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  let history = useHistory();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      const payload = {
        idEntidad: entidadesStore.activo.id,
        ...bloquesPedagogicosStore.params,
      };
      dispatch({ type: PARAMS_BLOQUES_PEDAGOGICOS, payload });
      if (
        bloquesPedagogicosStore.all &&
        bloquesPedagogicosStore.all.length === 0
      ) {
        await allBloquesPedagogicosAction(dispatch, payload);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    let dataRows = [];
    bloquesPedagogicosStore.all.forEach((el) => {
      dataRows.push({
        ...el,
        desde: el.fechaActiva ? el.fechaActiva.desde : 'N/A',
        hasta: el.fechaActiva ? el.fechaActiva.hasta : 'N/A',
        periodoAcademico: el.fechaActiva
          ? `${el.fechaActiva.periodoAcademico.desde}-${el.fechaActiva.periodoAcademico.hasta} (${el.fechaActiva.periodoAcademico.nombre})`
          : 'N/A',
        estatus: el.estatus.nombre,
        actions: el,
      });
    });
    setRows(dataRows);
  }, [bloquesPedagogicosStore.all]);

  const _handleEditClick = async (id) => {
    const data = bloquesPedagogicosStore.all.find((el) => el.id === id);
    await setActivoBloquesPedagogicosAction(dispatch, data);
    setOpenModalForm(true);
  };

  async function _onDeleteHandler() {
    setLoadingDelete(true);
    await deleteBloquesPedagogicosAction(
      { dispatch, notify },
      bloquesPedagogicosStore.activo.id,
      bloquesPedagogicosStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  }

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <NameComponent
              onClick={() => _handleEditClick(tableMeta.rowData[0])}
            >
              {value}
            </NameComponent>
          );
        },
      },
    },
    {
      name: CONST.abrev.name,
      label: CONST.abrev.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.numero.name,
      label: CONST.numero.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.desde.name,
      label: CONST.desde.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return dateformat(value, { inverse: true });
        },
      },
    },
    {
      name: CONST.hasta.name,
      label: CONST.hasta.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return dateformat(value, { inverse: true });
        },
      },
    },
    {
      name: CONST.periodoAcademico.name,
      label: CONST.periodoAcademico.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <BotonComponent
                click={async () => {
                  await setActivoBloquesPedagogicosAction(dispatch, value);
                  history.push(ROUTES.panelBloquePedagogico.to);
                }}
                icon
                size="medium"
                transparentBg
                dashboardIcon
                tooltip="Panel de gestión"
              />
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  await setActivoBloquesPedagogicosAction(dispatch, value);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={bloquesPedagogicosStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {bloquesPedagogicosStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">
            {bloquesPedagogicosStore.activo.nombre}
          </Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoBloquesPedagogicos;
